import React, { useEffect, useMemo, useState } from 'react'
import styles from './statistic-modal.module.scss'
import { billingStatus } from '../../helpers/helpers'
import moment from 'moment'

export default function SendStatisticStepThree({ onSend, onSkip, surveyData, onExploreServices }) {
  const [isSending, setIsSending] = useState(false)
  const formatSalary = () => {
    if (!surveyData) return ''
    const { salary, salary_currency_symbol, salary_rate } = surveyData
    return `${salary_currency_symbol}${salary?.toLocaleString()}/${salary_rate}`
  }

  const dateFormat = JSON.parse(localStorage.getItem('settings'))?.date_format || 'MMM YYYY'

  const renderVacancyDetails = () => {
    if (!surveyData) return null

    const { vacancy_type, rank_name, vessel_name, vessel_type_name, country_name, join_date_range } = surveyData

    if (vacancy_type === 'land') {
      return (
        <p className={styles['statisticStepOne__vacancyInfo']}>
          <span className={styles['statisticStepOne__infoLabel']}>Land Vacancy</span> |<strong> Rank:</strong>{' '}
          {rank_name} |<strong> Salary:</strong> {formatSalary()} |<strong> Country:</strong> {country_name || 'N/A'} |
          <strong> Join Date:</strong>
          {join_date_range ? (
            <time dateTime={surveyData.join_date} className={styles['statisticStep__company-date']}>
              {surveyData.join_date_range.toUpperCase()} {moment(surveyData.join_date).format('MMM YYYY') || '–'}
            </time>
          ) : (
            <time dateTime={surveyData.join_date} className={styles['statisticStep__company-date']}>
              {moment(surveyData.join_date).format(dateFormat) || '–'}
            </time>
          )}
        </p>
      )
    }

    // Sea vacancy
    return (
      <p className={styles['statisticStepOne__vacancyInfo']}>
        <strong>Rank:</strong> {rank_name} |<strong> Salary:</strong> {formatSalary()} |
        {vessel_name ? (
          <>
            <strong> Vessel:</strong> {vessel_name} |<strong> Type:</strong> {vessel_type_name} |
          </>
        ) : (
          <>
            <strong> Vessel Type:</strong> {vessel_type_name} |
          </>
        )}
        <strong> Join Date:</strong>
        {join_date_range ? (
          <time dateTime={surveyData.join_date} className={styles['statisticStep__company-date']}>
            {' '}
            {surveyData.join_date_range.toUpperCase()} {moment(surveyData.join_date).format('MMM YYYY') || '–'}
          </time>
        ) : (
          <time dateTime={surveyData.join_date} className={styles['statisticStep__company-date']}>
            {moment(surveyData.join_date).format(dateFormat) || '–'}
          </time>
        )}
      </p>
    )
  }

  const seafarersOptions = useMemo(() => {
    if (surveyData && surveyData.vacancy_offers && surveyData.vacancy_offers.length > 0) {
      return surveyData.vacancy_offers.map((offer) => ({
        id: offer.seafarer_id,
        displayName: `${offer.name}`,
        originalData: offer,
        avatar: offer.avatar,
      }))
    } else {
      return []
    }
  }, [surveyData])
  const [selectedSeafarers, setSelectedSeafarers] = useState([])
  const [showAll, setShowAll] = useState(false)

  const handleSeafarerSelect = (seafarer) => {
    if (selectedSeafarers.some((selected) => selected.id === seafarer.id)) {
      setSelectedSeafarers((prev) => prev.filter((selected) => selected.id !== seafarer.id))
    } else {
      setSelectedSeafarers((prev) => [...prev, seafarer])
    }
  }
  const handleSend = () => {
    if (isSending) return

    setIsSending(true)

    const seafarerIds = selectedSeafarers.map((seafarer) => seafarer.id)
    onSend(seafarerIds)

    setTimeout(() => {
      setIsSending(false)
    }, 1000)
  }
  const handleExploreServices = () => {
    onExploreServices()
  }

  return (
    <div className={styles['statisticStepThree']}>
      <div className={styles['statisticStep__header']}>
        <b>Great to hear that!</b>
      </div>

      <p>
        Please select the seafarers you hired for this position. This helps us improve our platform and provide better
        opportunities for other seafarers.
      </p>

      {renderVacancyDetails()}

      <div className={styles['statisticStep__companies']}>
        {seafarersOptions && seafarersOptions.length > 0 ? (
          <>
            {(showAll ? seafarersOptions : seafarersOptions.slice(0, 10)).map((seafarer) => {
              const isSelected = selectedSeafarers.some((selected) => selected.id === seafarer.id)
              return (
                <button
                  key={seafarer.id}
                  onClick={() => handleSeafarerSelect(seafarer)}
                  className={styles['statisticStep__company']}
                  style={{
                    backgroundColor: isSelected ? '#1e3d32' : '#f4fbf9',
                    color: isSelected ? 'white' : '#333',
                    borderColor: isSelected ? '#1e3d32' : '#dff0eb',
                  }}
                >
                  <div className={styles['statisticStep__company-image']}>
                    <img src={seafarer.avatar} alt="seafarer" />
                  </div>

                  <span>{seafarer.displayName}</span>
                </button>
              )
            })}
            {seafarersOptions.length > 10 && !showAll && (
              <>
                <button onClick={() => setShowAll(true)} className={styles['statisticStep__company']}>
                  More
                </button>
              </>
            )}
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            {surveyData && surveyData.no_surveys_found
              ? 'No surveys available at the moment'
              : surveyData
              ? 'No vacancies available'
              : 'Loading vacancies...'}
          </div>
        )}
      </div>

      <div className={styles['statisticStep__buttons']}>
        {selectedSeafarers.length > 0 ? (
          <button onClick={handleSend} className={styles['statisticStep__button--primary-full']} disabled={isSending}>
            {isSending ? 'Sending...' : 'Send'}
          </button>
        ) : (
          <div className={`${styles['statisticStep__buttons']} ${styles['statisticStep__buttons_column']}`}>
            {billingStatus() && (
              <button onClick={handleExploreServices} className={styles['statisticStep__button']}>
                Explore paid options
              </button>
            )}

            <button onClick={onSkip} className={styles['statisticStep__button--skip-full']}>
              Skip
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
